import { useServicesContext } from "@modules/core/services/services.context"
import { useObservable } from "micro-observables"
import { useQuery } from "@tanstack/react-query"
import { convertBoxFromDto } from "@modules/box/services/boxDto"

export const useBoxs = () => {
  const { boxService } = useServicesContext()
  return { result: useObservable(boxService.boxs), loading: useObservable(boxService.isLoadingBoxs) }
}

export const useSelectedBoxId = () => {
  const { currentSpaceManager } = useServicesContext()
  return useObservable(currentSpaceManager.currentBox).boxId
}

export const useBox = (id: string) => {
  const { boxApi } = useServicesContext()

  const { data, isLoading, isRefetching, error } = useQuery({
    queryKey: ["box", id],
    queryFn: async () => {
      return await boxApi.getBox(id)
    },
  })

  return {
    result: data ? convertBoxFromDto(data) : null,
    isRefetching,
    isLoading,
    error,
  }
}

export const useCurrentBox = () => {
  const id = useSelectedBoxId()
  const { boxApi } = useServicesContext()
  const { data, isLoading, error } = useQuery({
    queryKey: ["box", id],
    queryFn: async () => {
      if (id) {
        return await boxApi.getBox(id)
      }
      return null
    },
  })

  return { result: data ? convertBoxFromDto(data) : null, isLoading, error }
}
